export const home = {
  // Hero Section
  heroTitle: 'Üstün Çelik Donatı Teli Çözümleri',
  heroSubtitle: 'Dayanıklılık için tasarlandı, güç için mühendislik yapıldı. DYNAMIX kancalı uçlu çelik donatı telleri, kritik altyapı projelerinde beton güçlendirmede olağanüstü performans sunar.',

  // Features
  featuresTitle: 'Neden DYNAMIX Çelik Donatı Teli',
  featuresSubtitle: 'İleri mühendislik, üstün performansla buluşuyor',

  feature1Title: 'Üstün Çekme Dayanımı',
  feature1Desc: '1000-1200 MPa çekme dayanımına sahip yüksek kaliteli çelik, maksimum yük taşıma kapasitesi ve yapısal bütünlük sağlar.',

  feature2Title: 'Optimize Edilmiş Kancalı Uç Tasarımı',
  feature2Desc: 'Mühendislik kanca geometrisi, beton matrisinde olağanüstü ankraj sağlar ve stres altında tel çekilmesini önler.',

  feature3Title: 'Gelişmiş Çatlak Kontrolü',
  feature3Desc: 'Düzgün tel dağılımı, çatlak yayılmasını etkili bir şekilde kontrol eden üç boyutlu bir güçlendirme ağı oluşturur.',

  feature4Title: 'Korozyon Direnci',
  feature4Desc: 'Koruyucu kaplamalı premium çelik bileşimi, zorlu çevre koşullarında uzun vadeli dayanıklılık sağlar.',

  feature5Title: 'Kolay Uygulama',
  feature5Desc: 'Serbest akışlı teller betonla kolayca karışır, topaklanma olmadan düzgün dağılım sağlar.',

  feature6Title: 'Maliyet Etkin',
  feature6Desc: 'İşçilik maliyetlerini ve inşaat süresini azaltırken geleneksel hasır donatı ihtiyacını ortadan kaldırır.',

  // Applications Preview
  applicationsTitle: 'Kanıtlanmış Uygulamalar',
  applicationsSubtitle: 'Dünya çapında kritik altyapı projelerinde güvenilir',

  app1Title: 'Endüstriyel Zeminler',
  app1Desc: 'Yoğun trafikli depolar ve üretim tesisleri',

  app2Title: 'Tünel Kaplamaları',
  app2Desc: 'Yeraltı altyapısı ve madencilik operasyonları',

  app3Title: 'Barajlar ve Hidrolik Yapılar',
  app3Desc: 'Büyük ölçekli su altyapısı ve hidroelektrik projeleri',

  app4Title: 'Prefabrik Elemanlar',
  app4Desc: 'Mimari ve yapısal prefabrik bileşenler',

  viewAllApplications: 'Tüm Uygulamaları Görüntüle',

  // Technical Excellence
  technicalTitle: 'Teknik Mükemmellik',
  technicalSubtitle: 'En yüksek uluslararası standartlarda üretilmiştir',

  tech1Title: 'ASTM A820 Sertifikalı',
  tech1Desc: 'Fiber takviyeli betonda kullanılan çelik teller için ASTM A820 standardının tüm gereksinimlerini karşılar.',

  tech2Title: 'ISO 9001 Kalite',
  tech2Desc: 'Tutarlı ürün kalitesi sağlayan sıkı ISO 9001 kalite yönetim sistemi altında üretilmiştir.',

  tech3Title: 'İleri Test',
  tech3Desc: 'Her parti, çekme dayanımı, geometri ve performans özellikleri için titiz testlerden geçer.',

  tech4Title: 'Teknik Destek',
  tech4Desc: 'Karışım tasarımı, dozaj hesaplama ve uygulama rehberliği için uzman mühendislik desteği.',

  // CTA
  ctaTitle: 'Projenizi Güçlendirmeye Hazır mısınız?',
  ctaSubtitle: 'Beton güçlendirme ihtiyaçlarınız için uzman danışmanlık ve teknik destek alın.',
  getInTouch: 'İletişime Geçin',
};
